var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWholesalers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9315 20.0102L10.3301 13.2064L20.8887 9.15466L24.9438 19.628L17.981 22.3037C17.981 22.3037 16.5384 19.883 12.9315 20.0102Z",
    fill: "#18A6DC",
    stroke: "#18A6DC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6631 22.2557C13.5737 22.2513 14.4651 22.5171 15.2243 23.0194C15.9835 23.5217 16.5764 24.2379 16.9279 25.0772C17.2793 25.9165 17.3736 26.8411 17.1986 27.734C17.0236 28.6268 16.5873 29.4477 15.945 30.0926C15.3027 30.7375 14.4832 31.1773 13.5905 31.3564C12.6977 31.5355 11.7719 31.4458 10.9302 31.0986C10.0885 30.7515 9.36895 30.1625 8.8626 29.4063C8.35626 28.6502 8.08596 27.7608 8.08595 26.851C8.08305 25.6352 8.56366 24.468 9.42205 23.6062C10.2804 22.7444 11.4463 22.2586 12.6631 22.2557Z",
    stroke: "#18A6DC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6731 25.6454C12.918 25.6522 13.1554 25.7309 13.3557 25.8718C13.556 26.0127 13.7103 26.2094 13.7994 26.4374C13.8884 26.6654 13.9082 26.9146 13.8562 27.1538C13.8043 27.393 13.683 27.6115 13.5074 27.7822C13.3318 27.9529 13.1098 28.068 12.8691 28.1133C12.6284 28.1586 12.3796 28.132 12.154 28.0368C11.9283 27.9416 11.7357 27.7821 11.6003 27.5781C11.4649 27.3742 11.3926 27.1349 11.3926 26.8901C11.3972 26.5554 11.5347 26.2362 11.7749 26.0028C12.015 25.7694 12.3381 25.6408 12.6731 25.6454Z",
    fill: "#18A6DC",
    stroke: "#18A6DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21761 23.2665C8.21761 23.2665 7.32322 24.543 7.29928 25.0248L4.69785 18.4503L6.61069 14.246L4.23876 8.20665H0.336914V6.60083H5.38667L11.0486 21.4317C11.0486 21.4317 9.91795 21.7651 9.5948 22.0433L7.37599 16.3861L6.45766 18.5267L8.21761 23.2665Z",
    fill: "#18A6DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8579 24.566L24.6674 21.9668L25.203 23.4193L18.3935 26.0949C18.3935 26.0949 18.3347 25.2428 17.8579 24.566Z",
    fill: "#18A6DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07666 5.84648L17.5471 1.74353L19.6425 7.08174L9.17203 11.1846L7.07666 5.84648Z",
    stroke: "#18A6DC",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesalers);
export default __webpack_public_path__ + "static/media/wholesalers.3ac806a567a4fafe504e65870b05a483.svg";
export { ForwardRef as ReactComponent };